import { ClassImporterExporter, ImportMap } from "@app/shared/resources/class-importer-exporter.service";

import { DbHelper } from "@app/shared/model/db-object.model";

export interface ClareSystem {
    id: number;

    name: string;
    uuid: string;
    premium: boolean;
    profileCompleted: boolean;

    notes: string | null;
    serialNumber: string | null;
    macAddress: string | null;
    createTime: number | null;

    // @TODO: Separate these into different type (only db table columns should be here)
    project?: [{ claresystemId: number }]; // used in clare-input-controller to see if attached to a project
    primaryContact?: number; // This is only used when retrieving customer locations in the routeguards.
    // Needed to add primary contact to result
}

export interface ClareSystemData {
    id: number;

    name: string;
    uuid: string;
    premium: boolean;
    profile_completed: boolean;

    create_time: number | null;
    mac_address: string | null;
    notes: string | null;
    serial_number: string | null;

    // @TODO: These are not coming from DB. Find out where we're setting / reading these and move these into a different type.
    project?: [{ claresystem_id: number }]; // used in clare-input-controller to see if attached to a project
    primaryContact?: number;
}

export class ClareSystemHelper extends DbHelper<ClareSystem, ClareSystemData> {
    static readonly importMap: ImportMap<ClareSystem, ClareSystemData> = [
        { i: "id", o: "id" },

        { i: "name", o: "name" },
        { i: "uuid", o: "uuid" },
        { i: "premium", o: "premium" },
        { i: "profile_completed", o: "profileCompleted" },

        { i: "notes", o: "notes" },
        { i: "create_time", o: "createTime" },
        { i: "mac_address", o: "macAddress" },
        { i: "serial_number", o: "serialNumber" },
    ];

    readonly importMap = ClareSystemHelper.importMap;

    static getDefault(): ClareSystem {
        return {
            uuid: null,
            serialNumber: null,
            name: "Home",
            profileCompleted: true,
            premium: true,
            id: null,
            macAddress: null,
            createTime: null,
            notes: null,
        };
    }

    // the static should be replaced
    dbTypeName = "claresystem";

    fromDbObject(controller: ClareSystemData): ClareSystem {
        const claresystem: ClareSystem = ClassImporterExporter.importObject(controller, this.importMap);

        if (controller?.primaryContact) {
            claresystem.primaryContact = controller.primaryContact;
        }

        return claresystem;
    }

    toDbObject(obj: ClareSystem): ClareSystemData {
        return ClassImporterExporter.exportObject(obj, this.importMap);
    }
}
